import config from './config';

export async function initAnalyticsSession() {
  const sessionData = {
    analyticsId: config.id,
    deviceInfo: {
      language: navigator.language,
      browserCodeName: navigator.appCodeName,
      browserName: navigator.appName,
      browserVersion: navigator.appVersion,
      cookieEnabled: navigator.cookieEnabled,
      onLine: navigator.onLine,
      platform: navigator.platform,
      userAgent: navigator.userAgent,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    },
    meta: {
      currSessionInfo: {
        sessionStart: Date.now(),
        referrer: document.referrer,
      },
    },
  };
  await config.ANALYTICS_SERVICE.postAnalytics(sessionData);
}
